module.exports = __webpack_public_path__ + "static/media/ks_testtube3.5bd79f54.svg";